<div class="information">
  @if (geoinfos?.length > 0) {
    <rask-tabs [size]="2" layout="child">
      @for (geoinfo of geoinfos; track geoinfo; let index = $index) {
        <rask-tab [label]="$any(index + 1)">
          <label>{{ index + 1 }}.&nbsp;{{ geoinfo.label }}</label>
          <div class="scroll">
            <table class="info-table">
              <thead></thead>
              <tbody>
                @for (attr of geoinfo.attributes; track attr) {
                  <tr class="info-label-row" [ngbTooltip]="getTooltip(attr)">
                    <td class="info-label-key ellipsis">
                      <span>{{ attr.key }}</span>
                    </td>
                    <td class="info-label-value ellipsis">
                      @if (isUrl(attr.value)) {
                        <a href="{{ attr.value }}" target="_blank">{{ attr.value
                        }}</a>
                      }
                      @if (!isUrl(attr.value)) {
                        <span>{{ attr.value }}</span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </rask-tab>
      }
    </rask-tabs>
  }
</div>